<template>
  <v-container background pa-3 fluid>
    <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 style="margin-top:15px;">
            <p style="font-size:20px; padding:10px 0;">{{ $t("SocialSecurityKor20") }}</p>
          </v-flex>
          <v-flex lg2 md4 xs12 px-1>
            <v-select
              v-model="year"
              :items="years"
              :label="$t('Taxyear')"
              item-text="name"
              item-value="name"
            ></v-select>
          </v-flex>
          <v-flex lg2 md4 xs12 px-1>
            <v-select
              :items="branch_items"
              :label="$t('branch')"
              item-text="name"
              item-value="code"
              v-model="selectedBranch"
              hide-details
            />
          </v-flex>
        </v-layout>

        <v-layout row wrap style="margin-top:8px;">
          <v-flex xs12 px-1>
            <v-btn color="success" @click="process()">
              <v-icon class="pr-2" size="16">fa-file-download</v-icon>
              <span>{{ $t("Loaddata") }}</span>
            </v-btn>
            <v-btn color="info" @click="exportExcel()" v-if="tabledata">
              <v-icon class="pr-2" size="16">fa-file-excel</v-icon>
              <span>{{ $t("Exportexcel") }}</span>
            </v-btn>
            <v-btn color="primary" @click="copyTable()" v-if="tabledata">
              <v-icon class="pr-2" size="16">fa-copy</v-icon>
              <span>{{ $t("copy") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="tabledata" style="padding-top:15px;">
          <v-flex xs12>
            <div style="overflow-x:auto;">
              <table
                id="ss_kor20_table"
                border="1"
                style="border-collapse:collapse; width:100%; font-size:13px; min-width:900px;"
              >
                <thead>
                  <tr style="background-color:#1565C0; color:#fff; text-align:center;">
                    <th rowspan="3" style="padding:6px 8px; min-width:60px;">เดือน</th>
                    <th rowspan="3" style="padding:6px 8px; min-width:60px;">จำนวน<br/>ลูกจ้าง</th>
                    <th colspan="4" style="padding:6px 8px;">
                      &#9312; ประเภทของค่าจ้างตามกฎหมาย (รวมทุกสาขา)
                    </th>
                    <th rowspan="3" style="padding:6px 8px; min-width:120px; background-color:#0D47A1;">
                      &#9313;<br/>ส่วนที่เกิน<br/>20,000/คน/เดือน
                    </th>
                    <th rowspan="3" style="padding:6px 8px; min-width:120px; background-color:#1B5E20; color:#fff;">
                      &#9312;-&#9313;=&#9314;<br/>ค่าจ้างสุทธิ<br/>ที่ต้องแจ้ง
                    </th>
                  </tr>
                  <tr style="background-color:#1976D2; color:#fff; text-align:center;">
                    <th style="padding:4px 6px; min-width:110px;">เงินเดือน</th>
                    <th style="padding:4px 6px; min-width:110px;">ค่าจ้างรายวัน</th>
                    <th style="padding:4px 6px; min-width:110px;">ค่าตอบแทนอื่น ๆ</th>
                    <th style="padding:4px 6px; min-width:120px; background-color:#283593;">&#9312; รวมค่าจ้าง</th>
                  </tr>
                  <tr style="background-color:#1976D2; color:#FFECB3; text-align:center; font-size:11px;">
                    <td colspan="4" style="padding:3px 6px; font-style:italic;">
                      ** ไม่รวมเงินที่ไม่ใช่ค่าจ้าง เช่น ค่าล่วงเวลา โบนัส ฯลฯ **
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, i) in tableRows"
                    :key="i"
                    :style="i % 2 === 0 ? 'background-color:#fff' : 'background-color:#E3F2FD'"
                    style="text-align:right;"
                  >
                    <td style="text-align:center; padding:5px 8px; font-weight:500;">{{ monthName(row.month) }}</td>
                    <td style="text-align:center; padding:5px 8px;">{{ row.emp_count > 0 ? row.emp_count : '' }}</td>
                    <td style="padding:5px 8px;">{{ row.salary > 0 ? formatNumber(row.salary) : '' }}</td>
                    <td style="padding:5px 8px;">{{ row.daily_wage > 0 ? formatNumber(row.daily_wage) : '' }}</td>
                    <td style="padding:5px 8px;">{{ row.other_wage > 0 ? formatNumber(row.other_wage) : '' }}</td>
                    <td style="padding:5px 8px; background-color:#EDE7F6;">
                      {{ row.total_wage > 0 ? formatNumber(row.total_wage) : '' }}
                    </td>
                    <td style="padding:5px 8px; background-color:#E8EAF6;">
                      {{ row.excess_wage > 0 ? formatNumber(row.excess_wage) : '' }}
                    </td>
                    <td style="padding:5px 8px; background-color:#E8F5E9; font-weight:bold;">
                      {{ row.net_wage > 0 ? formatNumber(row.net_wage) : '' }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr style="background-color:#BDBDBD; font-weight:bold; text-align:right;">
                    <td colspan="2" style="text-align:center; padding:5px 8px;">รวม</td>
                    <td style="padding:5px 8px;">{{ totalSalary > 0 ? formatNumber(totalSalary) : '-' }}</td>
                    <td style="padding:5px 8px;">{{ totalDailyWage > 0 ? formatNumber(totalDailyWage) : '-' }}</td>
                    <td style="padding:5px 8px;">{{ totalOtherWage > 0 ? formatNumber(totalOtherWage) : '-' }}</td>
                    <td style="padding:5px 8px; background-color:#D1C4E9;">{{ totalWage > 0 ? formatNumber(totalWage) : '-' }}</td>
                    <td style="padding:5px 8px; background-color:#C5CAE9;">{{ totalExcess > 0 ? formatNumber(totalExcess) : '-' }}</td>
                    <td style="padding:5px 8px; background-color:#C8E6C9;">
                      &#9317; {{ totalNet > 0 ? formatNumber(totalNet) : '-' }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Loading -->
    <div class="text-xs-center">
      <v-dialog v-model="dialog_loading" persistent width="350">
        <v-card>
          <v-card-text>
            {{ $t("Loaddata") }}...
            <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="snackbarcolor">
      {{ snackmsg }}
      <v-btn dark flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import XLSX from "xlsx";
import numeral from "numeral";

const TH_MONTHS = ['', 'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

export default {
  data: () => ({
    years: [],
    year: new Date().getFullYear(),
    selectedBranch: "",
    branch_items: [],
    tabledata: false,
    tableRows: [],
    dialog_loading: false,
    snackbar: false,
    snackmsg: "",
    snackbarcolor: "red",
    totalSalary: 0,
    totalDailyWage: 0,
    totalOtherWage: 0,
    totalWage: 0,
    totalExcess: 0,
    totalNet: 0,
  }),

  computed: {
    ...mapState("app", ["showLoading"]),
  },

  created() {
    this.createYears();
    this.year = new Date().getFullYear();
    this.commitSetToolbar({ patternTool: "0" });
    this.getProfileBranchList();
  },

  methods: {
    ...mapActions("app", ["commitSetToolbar"]),

    monthName(m) {
      return TH_MONTHS[m] || '';
    },

    createYears() {
      const curYear = new Date().getFullYear();
      for (let y = curYear; y >= curYear - 10; y--) {
        this.years.push({ name: y });
      }
    },

    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          if (res.data.content && res.data.content.length > 0) {
            this.branch_items = [{ code: "", name: "ทั้งหมด" }];
            res.data.content.forEach((el) => this.branch_items.push(el));
          }
        })
        .catch((err) => console.log(err));
    },

    process() {
      if (!this.year) {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกปี";
        this.snackbarcolor = "error";
        return;
      }
      this.dialog_loading = true;
      this.tabledata = false;
      DocumentService.getSocialSecurityByYear(this.year, this.selectedBranch)
        .then((res) => {
          this.dialog_loading = false;
          this.buildTable(res.data);
        })
        .catch((err) => {
          console.log(err);
          this.dialog_loading = false;
          this.snackbar = true;
          this.snackmsg = "เกิดข้อผิดพลาดในการดึงข้อมูล";
          this.snackbarcolor = "error";
        });
    },

    buildTable(data) {
      this.tableRows = Array.isArray(data) ? data : [];
      this.totalSalary    = this.tableRows.reduce((s, r) => s + (Number(r.salary) || 0), 0);
      this.totalDailyWage = this.tableRows.reduce((s, r) => s + (Number(r.daily_wage) || 0), 0);
      this.totalOtherWage = this.tableRows.reduce((s, r) => s + (Number(r.other_wage) || 0), 0);
      this.totalWage      = this.tableRows.reduce((s, r) => s + (Number(r.total_wage) || 0), 0);
      this.totalExcess    = this.tableRows.reduce((s, r) => s + (Number(r.excess_wage) || 0), 0);
      this.totalNet       = this.tableRows.reduce((s, r) => s + (Number(r.net_wage) || 0), 0);
      this.tabledata = true;
    },

    formatNumber(val) {
      return numeral(val || 0).format("0,0.00");
    },

    exportExcel() {
      const headers = [
        'เดือน', 'จำนวนลูกจ้าง',
        'เงินเดือน', 'ค่าจ้างรายวัน', 'ค่าตอบแทนอื่น ๆ', '① รวมค่าจ้าง',
        '② ส่วนที่เกิน 20,000/คน/เดือน', '③ ค่าจ้างสุทธิที่ต้องแจ้ง'
      ];
      const rows = this.tableRows.map(r => [
        this.monthName(r.month),
        r.emp_count || 0,
        Number(r.salary) || 0,
        Number(r.daily_wage) || 0,
        Number(r.other_wage) || 0,
        Number(r.total_wage) || 0,
        Number(r.excess_wage) || 0,
        Number(r.net_wage) || 0,
      ]);
      rows.push([
        'รวม', '',
        this.totalSalary, this.totalDailyWage, this.totalOtherWage,
        this.totalWage, this.totalExcess, this.totalNet
      ]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'กท.20ก');
      XLSX.writeFile(wb, 'กท20ก_' + this.year + '.xlsx');
    },

    copyTable() {
      const el = document.getElementById('ss_kor20_table');
      if (el) {
        const range = document.createRange();
        range.selectNode(el);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        this.snackbar = true;
        this.snackmsg = "คัดลอกข้อมูลเรียบร้อย";
        this.snackbarcolor = "success";
      }
    },
  },
};
</script>
